import { Controller } from "@hotwired/stimulus"

let scriptPromise

function loadTurnstile() {
  if (window.turnstile) return Promise.resolve(window.turnstile)
  if (!scriptPromise) {
    scriptPromise = new Promise((resolve, reject) => {
      const script = document.createElement("script")
      script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit"
      script.async = true
      script.defer = true
      script.dataset.cookieconsent = "ignore"
      script.onload = () => resolve(window.turnstile)
      script.onerror = () => {
        script.remove()
        scriptPromise = undefined
        reject(new Error("Turnstile unavailable"))
      }
      document.head.appendChild(script)
    })
  }
  return scriptPromise
}

export default class extends Controller {
  static targets = ["widget", "error"]
  static values = { siteKey: String, action: String, language: String, size: { type: String, default: "flexible" } }

  async connect() {
    this.verified = false
    this.abortController = new AbortController()
    const { signal } = this.abortController
    const form = this.element.closest("form")
    form.addEventListener("submit", event => {
      if (!this.verified) {
        event.preventDefault()
        this.errorTarget.hidden = false
      }
    }, { signal })
    form.addEventListener("turbo:submit-end", () => this.reset(), { signal })
    document.addEventListener("turbo:before-cache", () => this.removeWidget(), { signal })

    try {
      const turnstile = await loadTurnstile()
      if (signal.aborted || !this.element.isConnected) return
      this.widgetId = turnstile.render(this.widgetTarget, {
        sitekey: this.siteKeyValue,
        action: this.actionValue,
        language: this.languageValue,
        size: this.sizeValue,
        theme: "light",
        callback: () => {
          this.verified = true
          this.errorTarget.hidden = true
        },
        "error-callback": () => {
          this.verified = false
          this.errorTarget.hidden = false
        },
        "expired-callback": () => this.reset()
      })
    } catch {
      if (!signal.aborted) this.errorTarget.hidden = false
    }
  }

  reset() {
    this.verified = false
    if (this.widgetId !== undefined) window.turnstile.reset(this.widgetId)
  }

  removeWidget() {
    this.verified = false
    if (this.widgetId !== undefined) {
      window.turnstile.remove(this.widgetId)
      this.widgetId = undefined
    }
  }

  disconnect() {
    this.abortController.abort()
    this.removeWidget()
  }
}
